import * as React from 'react';
export const fifththirdSvg = React.forwardRef(function fifththirdSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 0v105.909C0 130.227 17.635 150 39.324 150H150V44.09C150 19.774 132.365 0 110.676 0H0Z',
      fill: '#26D07C',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.081 6.818h104.595c18.243 0 33.243 16.818 33.243 37.273v99.091H39.324c-18.243 0-33.243-16.818-33.243-37.273V6.819Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M107.527 116.479h-23.09s13.698-3.275 11.35-15.5c-1.565-8.078-10.371-12.444-10.371-12.444 14.284-3.275 10.567-15.5 10.567-15.5s-2.349-8.951-11.545-12.444h23.676c6.262 0 11.349 5.676 12.915 10.26 1.761 5.895.195 15.064-10.175 17.466 5.088 2.401 9.392 5.239 10.566 12.007 1.37 6.549-2.935 16.155-13.893 16.155Zm-47.167 1.964 21.133-87.542h4.892l-21.133 87.542H60.36ZM28.67 89.352c15.067-3.493 11.154-17.029 11.154-17.029S37.475 62.5 27.692 58.79h23.293c7.057 0 12.718 6.112 13.893 12.88 1.76 9.824-5.284 17.683-11.545 17.683H28.67Zm-.978-36.402h33.46V33.084h-33.46V52.95Zm81.97-39.54h-97.5v91.135c0 17.273 12.568 31.591 28.176 31.591h97.5V45c0-17.273-12.568-31.59-28.176-31.59Z',
      fill: '#1D4094',
    }),
  );
});
fifththirdSvg.defaultProps = {
  width: '150',
  height: '150',
  viewBox: '0 0 150 150',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var fifththird = {
  category: 'brand',
  colorable: false,
  name: 'fifththird',
  svg: fifththirdSvg,
};
